import { useNavigate } from 'react-router-dom';

export function UnauthorizedPage() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen flex items-center justify-center px-4 bg-cream">
      <div className="card text-center max-w-md">
        <div className="text-6xl mb-4">🚫</div>
        <h1 className="text-3xl font-bold mb-4 text-text-dark">
          Access Denied
        </h1>
        <p className="mb-6 text-text-secondary">
          You don't have permission to access this page. Please contact your
          administrator if you believe this is an error.
        </p>
        <button onClick={() => navigate('/dashboard')} className="btn-primary">
          Go to Dashboard
        </button>
      </div>
    </div>
  );
}
